import React, { ReactElement } from 'react';

interface StepHeaderProps {
    title: string;
    subtitle?: string;
    img?: {
        url: string;
        alt: string;
    };
}

const StepHeader = ({ title, subtitle, img }: StepHeaderProps): ReactElement<'div'> | null => {
    return (
        <div className="otz-main__header">
            {img && <img src={img.url} alt={img.alt} />}
            <h1 className="otz-main__title">
                <strong>{title}</strong>
            </h1>
            {subtitle && <p className="otz-main__subtitle c-gray">{subtitle}</p>}
        </div>
    );
};

export default StepHeader;
